import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AutoLoginClient } from 'app/auth/auto-login.client';
import { BzgToastService } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common';

@Component({
    selector: 'send-password-email',
    templateUrl: 'send-password-email.component.html',
    styleUrls: ['send-password-email.component.scss']
})
export class SendPasswordEmailComponent {
    public userEmail: string;
    public EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;

    @ViewChild('sendEmailForm', { static: false}) sendEmailForm: ElementRef;

    constructor(private _router: Router,
        private _location: Location,
        private _autoLoginClient: AutoLoginClient,
        private _toastService: BzgToastService,
        private _translateService: TranslateService) {
    }

    public back() {
        this._location.back();
    }

    public sendEmail() {
        if (this.isEmailValid(this.sendEmailForm)) {
            this._autoLoginClient.sendVerificationCode(this.userEmail).subscribe((response) => {
                switch (response) {
                    case 'SendVerificationCodeSuccessful':
                        this._router.navigate(['email-sent']);
                        break;
                    case 'SendVerificationCodeSMTPWrongConfiguration':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_WRONG_CONFIGURATION').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'SendVerificationCodeMissingSMTPConfiguration':
                        this._translateService.get('AUTOADMIN.MISSING_SMTP_CONFIGURATION').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    case 'SendVerificationCodeUserNotFound':
                    case 'SendVerificationCodeUnexpectedError':
                        this._translateService.get('AUTOADMIN.SEND_EMAIL_UNEXPECTED_ERROR').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                    default:
                        this._translateService.get('GLOBAL.GENERIC_ERROR_MSG').subscribe((message: string) => {
                            this._toastService.open(
                                message,
                                {
                                    type: 'error',
                                    duration: 0,
                                    verticalPosition: 'bottom',
                                    horizontalPosition: 'right'
                                });
                        });
                        break;
                }
            });
        }
    }

    private isEmailValid(form): boolean {
        let isValid = true;
        if (!this.userEmail || this.userEmail === '' || form.form.controls.userEmailInput.invalid) {
            isValid = false;
        }
        return isValid;
    }
}
